import React from "react";
import { BiEnvelope } from "react-icons/bi";
import { FormattedMessage } from "react-intl";
import StyledLink from "../StyledLink/StyledLink";

import "./topFooter.scss";
const TopFooter = () => {
  return (
    <div className="topFooter">
      <div className="bg"></div>
      <h1 className="mid-title">
        <FormattedMessage
          id="OurNews"
          defaultMessage="Subscribe to our newsletter"
        />
      </h1>

      <div className="input">
        <div className="icon">
          <BiEnvelope />
        </div>
        <input type="text" placeholder="Type mail here" />
        <button className="blackButton">
          <FormattedMessage id="subscribe" defaultMessage="Subscribe" />
        </button>
      </div>
    </div>
  );
};

export default TopFooter;
